export default {
  id: 'problemDescription/HISTORY_OF_CHIEF_COMPLAINT/v1',
  formSchema: {
    title: 'encounter:widget.problemDescription.historyOfChiefComplaint',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.problemDescription.historyOfChiefComplaint',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
